import { render, staticRenderFns } from "./form_invitation_data.vue?vue&type=template&id=57a7127a&scoped=true"
import script from "./form_invitation_data.vue?vue&type=script&lang=js"
export * from "./form_invitation_data.vue?vue&type=script&lang=js"
import style0 from "./form_invitation_data.vue?vue&type=style&index=0&id=57a7127a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a7127a",
  null
  
)

export default component.exports